import { SidebarCollapsibleItem } from '../components/SidebarCollapsibleItem';
import { SidebarGroupContent } from '../components/SidebarGroup';
import {
  SidebarMenu,
  SidebarMenuItem,
  SidebarNavigationItem,
} from '../components/SidebarMenu';
import {
  type SideBarConfig,
  type SidebarNavigationItemProps,
  type SidebarSubNavigationItemProps,
} from '../types/Sidebar.types';

type SidebarModulesProps = {
  config: SideBarConfig;
};

/**
 * Type guard to check if a navigation item has sub-items
 */
function hasSubItems(
  item: SidebarNavigationItemProps & {
    subItems?: SidebarSubNavigationItemProps[];
  },
): item is SidebarNavigationItemProps & {
  subItems: SidebarSubNavigationItemProps[];
} {
  return Boolean(item.subItems && item.subItems.length > 0);
}

export const SidebarModules = ({ config }: SidebarModulesProps) => {
  return (
    <SidebarGroupContent>
      <SidebarMenu>
        {config.map((item) => {
          if (hasSubItems(item)) {
            return <SidebarCollapsibleItem key={item.title} item={item} />;
          }

          return (
            <SidebarMenuItem key={item.title}>
              <SidebarNavigationItem {...item} tooltip={item.title} />
            </SidebarMenuItem>
          );
        })}
      </SidebarMenu>
    </SidebarGroupContent>
  );
};
